import {
  PaymentMethod,
  PaymentFrequency,
  CardTypes,
  PaymentDetailsData,
} from './types';

export const defaultPaymentDetails: PaymentDetailsData = {
  paymentFrequency: PaymentFrequency.Unspecified,
  paymentDate: '',
  paymentMethod: PaymentMethod.Unspecified,
  paymentCardType: CardTypes.Unspecified,
};

export const defaultBsbDetails = {
  bsb: '',
  bankName: '',
  branchAddress: '',
  branchPostcode: '',
};
